//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "feedback",
  data(){
      return {
        form:{
          message:'',
          phone:''
        }
      }
  },
  methods:{
    sendFeedBack(){
      var _this=this;
      if(!(/^1[3456789]\d{9}$/.test(this.form.phone))){
        this.$vux.alert.show({
          title:'提示',
          content:'手机号码错误',
        })
        return false;
      }
      this.axios.post('/xcx/User/message',this.form).then(res=>{
        this.$vux.alert.show({
          title:'提示',
          content:res.data.msg,
          onHide(){
            _this.$router.go(-1);
          }
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/feedback/feedback.vue